import { useState } from 'react';
import { useNavigate } from 'react-router';
import { useSelector, useDispatch } from 'react-redux';
import { Badge } from '@mui/material';
import { Menu, MenuItem, MenuButton } from '@szhsin/react-menu';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import PriorityHighOutlinedIcon from '@mui/icons-material/PriorityHighOutlined';
import '@szhsin/react-menu/dist/index.css';
import MenuIcon from '@mui/icons-material/Menu';
import './UserMenuButton.scss';
import { resetUserState } from '../../core/users/action';
import { APP_ROUTES } from '../../constants/app-routes';
import { openNotificationModal } from '../../core/notifications/action';

export default function UserMenuButton() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { areNewNotifications } = useSelector((store) => store.notifications);

  const logout = () => {
    dispatch(resetUserState());
    window.localStorage.clear();
    window.sessionStorage.clear();
    // navigate('/');
    window.location.href = '/';
  };

  const openNotificationsModal = () => {
    dispatch(openNotificationModal());
  };

  return (
    <>
      <Menu
        menuButton={
          <MenuButton className="ButtonDisplay" style={{ cursor: 'pointer' }}>
            <Badge
              badgeContent={' '}
              color="warning"
              invisible={!areNewNotifications}
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}>
              <MenuIcon />
              <AccountCircleIcon className="AccountCircle" />
            </Badge>
          </MenuButton>
        }>
        <MenuItem onClick={() => navigate(APP_ROUTES.VENDOR_PROFILE)}>Profile</MenuItem>
        <MenuItem onClick={openNotificationsModal}>
          Notifications
          {areNewNotifications && (
            <PriorityHighOutlinedIcon sx={{ fill: '#ee7e5b', width: '1.3rem' }} />
          )}
        </MenuItem>
        <MenuItem onClick={() => navigate('/app/reviews')}>Reviews</MenuItem>
        <MenuItem onClick={() => logout()}>Logout</MenuItem>
      </Menu>
      {/* <NotificationsModal isOpen={isNotificationsModalOpen} handleClose={closeNotificationsModal} /> */}
    </>
  );
}
